var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wifi",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    height: 400,
    viewBox: "6 50 500 400",
    width: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wifi3",
    fill: "#FFFFFF",
    fillOpacity: 0.4,
    d: "M462,175.86a309,309,0,0,0-411.44,0,21,21,0,1,0,28,31.29,267,267,0,0,1,355.43,0,21,21,0,0,0,28-31.31Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "four",
    attributeName: "fill-opacity",
    dur: "500ms",
    values: "0.4;1;0.4",
    calcMode: "linear",
    begin: "three.end+0.05s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "wifi2",
    fill: "#FFFFFF",
    fillOpacity: 0.4,
    d: "M256.28,183.7a221.47,221.47,0,0,0-151.8,59.92,21,21,0,1,0,28.68,30.67,180.28,180.28,0,0,1,246.24,0,21,21,0,1,0,28.68-30.67A221.47,221.47,0,0,0,256.28,183.7Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "three",
    attributeName: "fill-opacity",
    dur: "500ms",
    values: "0.4;1;0.4",
    calcMode: "linear",
    begin: "two.end+0.05s"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "wifi1",
    fill: "#FFFFFF",
    fillOpacity: 0.4,
    d: "M346.65,304.3a136,136,0,0,0-180.71,0,21,21,0,1,0,27.91,31.38,94,94,0,0,1,124.89,0,21,21,0,0,0,27.91-31.4Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "two",
    attributeName: "fill-opacity",
    dur: "500ms",
    values: "0.4;1;0.4",
    calcMode: "linear",
    begin: "one.end+0.05s"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    fill: "#FFFFFF",
    fillOpacity: 0.4,
    cx: 256.28,
    cy: 393.41,
    r: 32
  }, /*#__PURE__*/React.createElement("animate", {
    id: "one",
    attributeName: "fill-opacity",
    dur: "500ms",
    values: "0.4;1;0.4",
    calcMode: "linear",
    begin: "0s;four.end+0.05s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiAnimation);
export default __webpack_public_path__ + "static/media/wifi-animation.d6a2318658bf24aad6f1e44e6376e1ef.svg";
export { ForwardRef as ReactComponent };